const $ = require('jquery');
window.jQuery = $;
window.$ = $;

require('./js/libraries/jquery.typeahead.min.css');
require('qrcode');



// WEBPACK FOOTER //
// ./public/src/vendor.js